export enum DatepickerRangeOptions {
  allDates,
  today,
  yesterday,
  last2Days,
  last3Days,
  lastWeek,
  lastMonth,
  lastYear,
  last24hours,
  last48hours,
  last72hours,
  tomorrow,
  next2Days,
  next3Days,
  next7Days,
  next30Days,
  customRange
}

export interface DatepickerRangeOption {
  label: string;
  value: DatepickerRangeOptions;
  disabled: boolean;
}
